<template>
    <section class="component-contact-form">
        <div class="container-fluid">
            <div class="row">
                <div class="col" v-if="title && title != ''">
                    <header>
                        <h2 class="text-right rtl font-18 mb-4">{{title}}</h2>
                    </header>
                </div>
                <div class="col-12">
                    <div class="wrapper-form py-4">
                        <form class="row px-2" @submit.prevent>
                            <!-- <div class="w-100 d-none d-md-block"></div> -->
                            <div :class="['col-md-'+item.col,{'w-100 d-none d-md-block':item.clear}]" v-for="(item,index) in inputs" :key="index">
                                <div v-if="item.type == 'btn'">
                                    <div class="form-action ">
                                        <button :class="['font-16 px-5 py-2 bttn-fill bttn bttn-'+item.mode]" v-ripple @click="$emit(item.methodsName,inputs)">{{item.label}}</button>
                                    </div>
                                </div>
                                <div class="group-form" :class="[item.modeDir]" v-if="item.type == 'input' || item.type == 'textarea'">
                                    <!-- || item.model == 0 -->
                                    <strong class="text-left ltr d-inline-block holder" v-if="item.holder && item.model === ''">{{item.holder}}</strong>
                                    <input v-if="item.type=='input'" type="text" v-validate="item.rule" :name="item.name" :class="{active:item.model != '' }" v-model="item.model">
                                    <textarea  v-if="item.type=='textarea'" v-validate="item.rule" :name="item.name" :class="{active:item.model != ''}" v-model="item.model"></textarea>
                                    <span class="bar"></span>
                                    <label :class="{'statr':item.star}">{{ item.label }}</label>
                                    <span v-if="errors.has(item.name)" class="is-danger">{{item.msg}}</span>
                                </div>
                                <div class="start-box rtl text-right" v-if="item.type=='rate'">
                                    <label :class="{'statr':item.star}">{{ item.label }}</label>
                                    <div class="clearfix"></div>
                                    <star-rating class="d-inline-block" :rtl="true" :star-size="20" :show-rating="false" v-model="item.model" :active-color="'#f4c150'" :rounded-corners="false" :inactive-color="'#ccc'" />
                                    <p class="d-inline-block rtl text-right">
                                        {{item.model}}
                                    </p>
                                </div>
                                <div class="input-checkbox rtl text-right" v-if="item.type=='checkbox'">
                                    <div class="md-checkbox">
                                        <input type="checkbox" :id="item.name" v-model="item.model">
                                        <label :for="item.name" class="font-14">{{item.label}}</label>
                                    </div>
                                </div>
                                <div class="upload-photo rtl text-right" v-if="item.type=='file'">
                                    <div class="input-group mb-3">
                                        <div class="custom-file">
                                            <input type="file" class="custom-file-input" :accept="item.accept || 'image/*'" :id="item.name" :ref="item.name" v-on:change="handleFileUpload($event,item.name)" />
                                            <label class="custom-file-label pr-5" :for="item.name">
                                                <span class="pr-5">
                                                    {{item.model.name}}
                                                </span>
                                            </label>
                                        </div>
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">{{item.label || 'آپلود فایل تصویری'}}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="group-form rtl text-right" v-if="item.type=='select'">
                                    <!-- <label :class="{'statr':item.star}" v-if="item.model != ''">{{ item.label }}</label> -->
                                    <select v-validate="item.rule" :name="item.name" v-model="item.model" @change="$emit(item.eventname,item)">
                                        <option value="" selected disabled>{{item.label}}</option>
                                        <option v-for="(option,index) in item.options" :value="option[item.val]" :key="index">
                                            {{option[item.textVal]}}
                                        </option>
                                    </select>
                                    <span v-if="errors.has(item.name)" class="is-danger">{{item.msg}}</span>

                                </div>
                                <div class="editor rtl text-right my-4" v-if="item.type == 'editor'">
                                    <label :class="{'statr':item.star}">{{ item.label }}</label>
                                    <!-- <input type="hidden" v-validate="item.rule" :name="item.name"  v-model="item.model"> -->
                                    <quill-editor @ready="onEditorReady($event)" v-model="item.model" />
                                    <!-- <div class="group-form rtl m-0 text-right">
                                        <span v-if="errors.has(item.name)" class="is-danger">{{item.msg}}</span>
                                    </div> -->
                                </div>
                            </div>
                        </form>
                        <div class="row px-2 d-flex  align-items-end" v-if="action">
                            <div class="col">
                                <div class="form-action ">
                                    <button class="font-16 px-5 py-2 bttn-fill bttn bttn-success" v-ripple @click="submited(inputs)">
                                        <!-- ارسال -->
                                        {{labelBtn}}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import uploadPhoto from 'cp/min-component/upload-photo.vue'
export default {

    name: 'component-contact-form',
    // props: ['inputs', 'title', 'action'],
    props: {
        action: {
            type: Boolean,
            default: false,
            required: true
        },
        inputs: {
            type: Array,
            default: () => [],
            required: true
        },
        title: {
            type: String,
            default: null,
            required: true
        },
        labelBtn: {
            type: String,
            default: 'ارسال',
            required: false
        }
    },
    components: {
        uploadPhoto
    },
    data () {
        return {
        }
    },
    mounted () {
        this.$emit('formReady')
    },
    methods: {
        async submited (inputs) {
            let result = await this.$validator.validate()
            if (result) {
                this.$emit('submitAction', inputs)
            } else {
                this.$root.showWarnMsg({
                    message: 'لطفا فرم را تکمیل کنید ... '
                })
            }
        },
        onEditorReady (editor) {
            editor.format('direction', 'rtl')
            editor.format('align', 'right')
        },
        handleFileUpload (e, name) {
            var files = e.target.files
            this.$emit('setFormData', files[0])
            // if (!files[0]) {
            //     return;
            // }
            // var data = new FormData();
            // data.append(name, files[0])
        }
    }
}
</script>

<style lang="less">
.component-contact-form {
  @import (reference) "../assets/css/variable.less";
  .box-clear;
}
</style>



// WEBPACK FOOTER //
// src/components/contact-form.vue